module.exports = __webpack_public_path__ + "img/tab_analytics-w.e5ada109.svg";